(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaSnomedDeleteController',RcopiaSnomedDeleteController);

    RcopiaSnomedDeleteController.$inject = ['$uibModalInstance', 'entity', 'RcopiaSnomed'];

    function RcopiaSnomedDeleteController($uibModalInstance, entity, RcopiaSnomed) {
        var vm = this;

        vm.rcopiaSnomed = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RcopiaSnomed.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
